<template>
  <div id="bodySubBiz"
       :class="$attrs.platform === 'mobile'
        ? biz.mobile
        : biz.desktop"
       class="column justify-end items-center bg-color_darkBlue relative-position">
    <div id="bizPaper"
         :class="$attrs.platform === 'mobile'
         ? biz.paperMobile
         : biz.paperDesktop"
         class="column items-center">
      <div :class="$attrs.platform === 'mobile'
           ? biz.imgMobile
           : biz.imgDesktop">
        <q-img no-spinner
               src="@/assets/images/img_body_biz_link.png"/>
      </div>
      <div class="column full-width items-center">
        <p :class="$attrs.platform === 'mobile'
              ? 'text-body_normal_bold text-center'
              : 'text-title_normal_bold'"
           class="text-color_black text-center" v-html="$attrs.platform === 'mobile' ? $attrs.lang.titleMobile : $attrs.lang.title">
        </p>
        <p :class="$attrs.platform === 'mobile'
            ? 'text-caption_large q-px-md'
            : 'text-body_normal'"
           class="text-center subTitle q-mb-xl"
           v-html="$attrs.lang.subTitle"/>
        <q-btn
            :href="`mailto:${bizEmail}`"
            :ripple="false"
            class="email row text-color_white bg-color_vitoBlue"
            flat
            size="xs"
            @mousedown="logEvent('action_section5_button_b2b')"
            tabindex="25">
          <q-icon
              name="email"
              size="xs"/>
          <p :class="$attrs.platform === 'mobile'
              ? 'text-body_small_bold'
              : 'text-body_small_bold'"
             class="no-margin q-pl-sm">
            {{ $attrs.lang.link }}
          </p>
        </q-btn>
        <p :class="$attrs.platform === 'mobile' ? 'text-caption_large' : 'text-body_small'"
           class="q-mb-md q-pt-xl text-color_lightgray3">
          {{ $attrs.lang.partners }}
        </p>
        <div class="row gap"
          :class="$attrs.platform === 'mobile'
            ? biz.wrapperMobile
            : biz.wrapperDesktop"
        >
          <div v-for="(partner, idx) in partners"
               :key="idx"
               :class="$attrs.platform === 'mobile' ? biz.partnerMobile : biz.partnerDesktop">
            <q-img :src="require(`@/assets/images/img_body_biz_${partner}_logo.png`)"
                   no-spinner/>
          </div>
        </div>

      </div>
    </div>
    <!--    <div :class="biz.bg"/>-->
  </div>
</template>

<script setup>
// Imports

import { useStore } from 'vuex'
import { computed, reactive, onMounted } from 'vue'
import { paperMoveUp } from '@/utils/biz'
import { logEvent } from '../utils/amplitude'

// Props

// Emits

// Variables

const store = useStore()

// Responses

const pageMaxWidth = reactive(computed(() => store.getters.getPageMaxWidth + 'px'))
const pageMaxHeight = reactive(computed(() => store.getters.getBizMaxHeight + 'px'))
const partners = reactive(computed(() => store.getters.getBizPartners))
const bizEmail = reactive(computed(() => store.getters.getBizEmail))

// Methods

// Lifecycles

onMounted(() => paperMoveUp())

</script>

<style module="biz">

.desktop {
  width: 100%;
  /*border-radius: 8px;*/
  /*max-width: v-bind(pageMaxWidth);*/
  height: v-bind(pageMaxHeight);
}

.mobile {
  width: 100%;
  padding: 0;
  height: 540px;
}

.imgDesktop {
  position: absolute;
  top: -42px;
  left: 50%;
  transform: translateX(-50%);
  width: 72px;
  margin-top: 6px;
  margin-right: 24px;
}

.imgMobile {
  position: absolute;
  top: -42px;
  left: 50%;
  transform: translateX(-50%);
  width: 56px;
  margin-top: 14px;
  margin-right: 24px;
}

.paperDesktop {
  width: 100%;
  height: 100%;
  max-width: v-bind(pageMaxWidth);
  max-height: v-bind(pageMaxHeight);
  padding: 80px 20px !important;
  background-color: white;
  border-radius: 8px 8px 0 0;
}

.paperMobile {
  width: 100%;
  height: 100%;
  max-width: v-bind(pageMaxWidth);
  max-height: v-bind(pageMaxHeight);
  padding: 44px 0 0;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
}

.wrapperDesktop {
  max-width: 1032px;
  gap: 16px 8px;
}
.wrapperDesktop > div:nth-child(6) {
  margin-left: 100px;
}

.partnerDesktop {
  width: 200px;
  height: 60px;
}

.partnerMobile {
  width: 25%;
  height: 34px;
}

.wrapperMobile {
  max-width: 368px;
  width: 100vw;
  gap: 12px 0px;
}

.wrapperMobile > div:nth-of-type(5),
.wrapperMobile > div:nth-of-type(12) {
  margin-left: 12.5%;
}

.bg {
  position: absolute;
  height: v-bind(pageMaxHeight);
  top: 0;
  left: -50%;
  max-height: v-bind(pageMaxHeight);
  background-color: #000B28;
  z-index: -1;
}

.gap {
  gap: 24px;
}
</style>

<style scoped>
.email {
  background-color: #2E67FE;
  padding: 20px 34px !important;
  border-radius: 32px !important;
}
</style>
